(() => {
  if (window.StlModalAnalytics) return;

  const getStlAnalyticsSource = element => {
    let from = 'shop_my_look_details';
    if (document.querySelector('.slide-cart-modal.active')) {
      from = 'slide_cart';
    }
    if (document.body.dataset.template?.startsWith('cart')) {
      from = 'cart_page';
    }
    if (document.activeElement?.dataset.source) {
      from = document.activeElement.dataset.source;
    }
    return from;
  };

  const getStlModalContentUrl = modal => {
    const href =
      modal?.querySelector('.btn-details')?.getAttribute('href') ?? '';
    return href.split('/').filter(Boolean).pop() ?? '';
  };

  /**
   * Single dataLayer push: `shopTheLookOPenCloseEvent` already pushes (store-events.js).
   * Previously we pushed twice (direct + helper), so the event fired duplicate.
   */
  const fireProductColorChangeAnalytics = (
    modal,
    previousColorName,
    newColorName
  ) => {
    const type = getStlAnalyticsSource();
    const content_url = getStlModalContentUrl(modal);
    const parameter = JSON.stringify({
      from: previousColorName,
      value: newColorName,
      content_url,
      type
    });

    if (typeof window.shopTheLookOPenCloseEvent === 'function') {
      window.shopTheLookOPenCloseEvent('product_color_change', parameter);
    } else if (typeof window.dataLayer?.push === 'function') {
      window.dataLayer.push({
        event: 'custom_event',
        event_name: 'product_color_change',
        parameter
      });
    }
  };

  const fireProductSizeChangeAnalytics = (modal, previousSize, newSize) => {
    const type = getStlAnalyticsSource();
    const content_url = getStlModalContentUrl(modal);
    const parameter = JSON.stringify({
      from: previousSize,
      value: newSize,
      content_url,
      type
    });

    if (typeof window.shopTheLookOPenCloseEvent === 'function') {
      window.shopTheLookOPenCloseEvent('product_size_change', parameter);
    } else if (typeof window.dataLayer?.push === 'function') {
      window.dataLayer.push({
        event: 'custom_event',
        event_name: 'product_size_change',
        parameter
      });
    }
  };

  const firePopupView = (item, index) => {
    if (typeof window.shopTheLookOPenCloseEvent !== 'function') return;
    const handle =
      item.dataset.stlProductHandle ||
      (item.dataset.stlProductUrl || '').split('/').filter(Boolean).pop() ||
      '';
    window.shopTheLookOPenCloseEvent(
      'product_popup_view',
      JSON.stringify({
        from: getStlAnalyticsSource(),
        item_name: handle,
        item_number: String(index),
        item_id: item.dataset.urlId,
        product_color: item.dataset.productColor,
        product_collection: item.dataset.mainCollections
      })
    );
  };

  const getStlAddToCartAnalyticsPayload = modal => {
    const checkedInput = modal?.querySelector(
      '.shop-look__modal-sizes input[type="radio"]:checked'
    );

    let variantId;
    let priceCents;

    if (checkedInput instanceof HTMLInputElement) {
      variantId = checkedInput.dataset.variantId;
      priceCents = Number(checkedInput.dataset.price);
    } else {
      /* Single-variant products render no size radios (stl-modal-size-options.liquid
       * only renders the radio list when the size option has more than one value) —
       * fall back to the form's variant input and the modal's default-variant data. */
      variantId = modal?.querySelector('.product-variant-id')?.value;
      priceCents =
        variantId && variantId === modal?.dataset?.defaultVariantId
          ? Number(modal.dataset.defaultVariantPrice)
          : NaN;
    }

    const handle = String(modal?.dataset?.productHandle || '').trim();

    if (!variantId || !handle) return null;

    let productColor = modal.dataset.productColor ?? '';
    let productCollection = modal.dataset.mainCollections ?? '';

    if (!productColor || !productCollection) {
      const listItem = document.querySelector(
        `.shop-look__item[data-stl-product-handle="${handle}"]`
      );
      if (listItem) {
        productColor = productColor || listItem.dataset.productColor || '';
        productCollection =
          productCollection || listItem.dataset.mainCollections || '';
      }
    }

    return {
      from: getStlAnalyticsSource(),
      item_id: variantId,
      price: Number.isFinite(priceCents) ? (priceCents / 100).toFixed(2) : '',
      quantity: 1,
      item_category: `/products/${handle}`,
      item_name: handle,
      product_color: productColor,
      product_collection: productCollection
    };
  };

  const fireStlAddToCartCustomAnalytics = modal => {
    const modalEl = modal ?? window.__stlModalSectionDeps?.getInjectedModal?.();
    if (!modalEl) return;

    const payload = getStlAddToCartAnalyticsPayload(modalEl);
    if (!payload) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'custom_event',
      event_name: 'add_to_cart_custom',
      parameter: JSON.stringify(payload)
    });
  };

  const STL_INGREDIENTS_ANALYTICS_FROM = 'product_pop_up';
  let stlIngredientsViewStartTime = null;

  const handleStlIngredientsAnalytics = isOpen => {
    if (isOpen) {
      stlIngredientsViewStartTime = new Date();

      if (typeof window.modalIngredientsEvent === 'function') {
        window.modalIngredientsEvent(
          'ingridient_pop_up_view',
          JSON.stringify({ from: STL_INGREDIENTS_ANALYTICS_FROM })
        );
      }

      return;
    }

    if (!stlIngredientsViewStartTime) return;

    if (typeof window.timingViewIngredientsEvent === 'function') {
      window.timingViewIngredientsEvent(
        STL_INGREDIENTS_ANALYTICS_FROM,
        stlIngredientsViewStartTime
      );
    }

    stlIngredientsViewStartTime = null;
  };

  window.StlModalAnalytics = {
    getStlAnalyticsSource,
    getStlModalContentUrl,
    fireProductColorChangeAnalytics,
    fireProductSizeChangeAnalytics,
    firePopupView,
    getStlAddToCartAnalyticsPayload,
    fireStlAddToCartCustomAnalytics,
    handleStlIngredientsAnalytics
  };
})();
